import { render } from "./WidgetStock.vue?vue&type=template&id=71761212"
import script from "./WidgetStock.vue?vue&type=script&lang=js"
export * from "./WidgetStock.vue?vue&type=script&lang=js"

import "./WidgetStock.vue?vue&type=style&index=0&id=71761212&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__